<!-- <p>incident-status-graph works!</p> -->
<div class="demo-chart-wrapper">
  <div
    echarts
    [options]="chartOption"
    (chartInit)="onChartInit($event)"
    [ngStyle]="height ? { height: height } : {}"
    class="demo-chart"
  ></div>
</div>
